import { render, staticRenderFns } from "./BoHeartDisease.vue?vue&type=template&id=9a6063e6&"
import script from "./BoHeartDisease.vue?vue&type=script&lang=js&"
export * from "./BoHeartDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports